import React, { useState } from "react";
// import { Button } from '../styles';
import "./CSS/scrolltop.css";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 1500) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <div className="container-fluid footer">
      <div className="container">
        <div className="row scrollbutton">
          <div
            className="scroll-top round"
            onClick={scrollToTop}
            style={{ display: visible ? "inline" : "none" }}
          >
            <ArrowUpwardIcon />
          </div>
        </div>
        <div className="row scrollbutton">
          <p className="footer-text">Saud Khan</p>
        </div>
      </div>
    </div>
  );
};

export default ScrollButton;
